export default __webpack_public_path__ + "static/media/根据地LIVEHOUSE.e29ea1ea.jpg";